const pageCallBtns = document.querySelectorAll('.pageCallBtn, .wpcf7-acceptance a');
const externOutputWindows = document.querySelectorAll(".externOutputWindow");
const openMobBtn = document.querySelector("#mobHeader .open-close-button");
const mobHeader = document.querySelector('header#mobHeader');
const mobHeadMenu = document.querySelector("#mobHeadMenu");
const mobHeadMenuLinks = mobHeadMenu.querySelectorAll("a");

const contactForm = document.querySelector("form");

//const mates = document.querySelectorAll('.mate');
const text_img = document.querySelectorAll(".has-subsections.content-order--text-img");
const closeExternBtn = document.querySelectorAll(".externOutputWindow .close-button");
const deskLogo = document.querySelector("#desktopHeader .header__logo img");
const mobLogo = document.querySelector("#mobHeader .header__logo img");
const menuRay = document.querySelector('#desktopHeader .ray');

//const mobMenuRay = document.querySelector('#mobHeader .ray');

const imgTiles = document.querySelectorAll('.img__tile');

const mobMenuUl = document.querySelector('#mobHeader nav ul');

const headerNav = document.querySelector("#desktopHeader nav");
const teaserPrints = document.querySelectorAll('.teaser-print');
const haveTrails = document.querySelectorAll('.has-trail');
const slogans = document.querySelectorAll('.slogan');

const appearSections = document.querySelectorAll('.appears');
let appearsSections__Array = [];

let mobHeadMenuHeight;

const desktopNavLIs = document.querySelectorAll('#desktopHeader nav li');
let desktopNavLIsTops_Array = [];

const mobNavLIs = document.querySelectorAll('#mobHeader nav li');
let mobNavLIsTops_Array = [];

mobHeadMenuLinks.forEach( (a) => {
  a.addEventListener("click", function(){
    mobHeadMenu.classList.remove('menu--open');
    mobHeadMenu.style.height = 0 + 'px';
    openMobBtn.classList.remove('menu--opened');
    mobHeader.classList.remove('shade');
  });
});

text_img.forEach( (div) => {
  div.querySelector('.main-section .text').classList.add('offset-md-1');
} );

text_img.forEach( (div) => {

  const subsectionsOdd = div.querySelectorAll('.subsection:nth-child(even)');
  const subsectionsEven = div.querySelectorAll('.subsection:nth-child(odd)');

  subsectionsOdd.forEach( (subsection) => {
    subsection.querySelector('.img').classList.add('offset-md-2');
  } );
  
  subsectionsEven.forEach( (subsection) => {
    subsection.querySelector('.text').classList.add('offset-md-1');
  } ); 
  
} );




/* === SECTION TRAILS === */

haveTrails.forEach( (trailing) => {
  
  const div = document.createElement('div');
  const hr = document.createElement('hr');
  let contentOrder;
  let trailSide;

  if( trailing.classList.contains('main-section') ){
    contentOrder = trailing.closest('.content-order');

    if( contentOrder.classList.contains('content-order--text-img') ){
      trailSide = "trail-left";
    } else if ( contentOrder.classList.contains('content-order--img-text') ){
      trailSide = "trail-right";
    }
  } else {
    contentOrder = trailing.querySelector('.content-order');
    
    if( contentOrder.classList.contains('content-order--text-img') ){
      trailSide = "trail-left";
    } else if ( contentOrder.classList.contains('content-order--img-text') ){
      trailSide = "trail-right";
    }
  }

  hr.classList.add(trailSide);

  div.appendChild(hr);

  div.classList.add('section-trail', 'mt-7', 'mt-lg-6', 'mt-xl-8');
  trailing.appendChild(div);
});

/* === // SECTION TRAILS === */




/* === fill ARRAY of DISTANCES TO TOP OF "APPEARS" SECTIONS === */

function getDistanceToDocumentTop(element) {
  let distance = 0;
  while (element) {
    distance += element.offsetTop;
    element = element.offsetParent;
  }
  return distance;
}

function appearsDistanceToTop() {  
  appearsSections__Array = [];
  appearSections.forEach( (section) => {
    const elemOffsetTop = getDistanceToDocumentTop(section);
    appearsSections__Array.push(elemOffsetTop);
  } );
}

/* === // fill ARRAY of DISTANCES TO TOP OF "APPEARS" SECTIONS === */




/* === calling EXTERNAL WINDOW === */

pageCallBtns.forEach( (btn) => {
  let btnHref = btn.getAttribute('href');

  btn.addEventListener("click", function(e) {
    e.preventDefault();
    btnHref = btnHref.replace(/\//g, '');
    document.querySelector(".externOutputWindow#"+btnHref).classList.remove('closed');
    document.querySelector(".externOutputWindow#"+btnHref).classList.add('opened');
  });
});

const externOutputWindowLinks = document.querySelectorAll('.externOutputWindow__inner-content .inner-content__text a');

externOutputWindowLinks.forEach( (a) => {
  let btnHref = a.getAttribute('href');

  a.addEventListener("click", function(e) {
    e.preventDefault();
    btnHref = btnHref.replace(/\//g, '');

	const windows = document.querySelectorAll('.externOutputWindow');

	windows.forEach( (win) => {
		win.classList.remove('opened');
		win.classList.add('closed');
	} );

	/*document.querySelector(".externOutputWindow").classList.remove('opened');
    document.querySelector(".externOutputWindow").classList.add('closed');*/

    document.querySelector(".externOutputWindow#"+btnHref).classList.remove('closed');
    document.querySelector(".externOutputWindow#"+btnHref).classList.add('opened');
  });
});

/* === // calling EXTERNAL WINDOW === */




/* === closing EXTERNAL WINDOW === */

closeExternBtn.forEach( (btn) => {
  btn.addEventListener("click", function() {
    btn.closest(".externOutputWindow").classList.remove("opened")
    btn.closest(".externOutputWindow").classList.add("closed");
  });
});

/* === // closing EXTERNAL WINDOW === */




/* === fill in MOBILE LIs === */

function fillMobMenuLIsTop(){
  for( let i=0; i < mobNavLIs.length; i++ ){
    const liTop = mobNavLIs[i].getBoundingClientRect().top;
    mobNavLIsTops_Array[i] = liTop;
  }
}

/* === // fill in MOBILE LIs === */




/* === calculating of HEIGHT of MOBILE MENU === */

function mobMenuCalc() {

  const topHead = document.querySelector('#mobHeaderTopWrap');

  if ( window.orientation === 0 || window.orientation === 180 ) {
    let winHeight = window.innerHeight;
    let topHeadHeight = topHead.offsetHeight;
    mobHeadMenuHeight = winHeight - topHeadHeight;
  } else {
    let winHeight = window.innerHeight;
    let topHeadHeight = topHead.offsetHeight;
    mobHeadMenuHeight = winHeight - topHeadHeight;
  }

  if( mobHeadMenu.classList.contains('menu--open') ){
    mobHeadMenu.style.height = mobHeadMenuHeight + 'px';
    openMobBtn.classList.add('menu--opened');
  } else {
    mobHeadMenu.style.height = 0 + 'px';
    openMobBtn.classList.remove('menu--opened');
  }
}

/* === // calculating of HEIGHT of MOBILE MENU === */




/* === position and height of MOBILE RAY === */

function mobRayPosition(){
  let mobMenuULRight = mobHeadMenu.querySelector('ul').getBoundingClientRect().right;
  let mobMenuULHeight = mobHeadMenu.querySelector('ul').getBoundingClientRect().height;
  let firstLITop = mobNavLIs[0].offsetTop;
  mobMenuRay.style.top = firstLITop + 'px';
  mobMenuRay.style.left = mobMenuULRight + 'px';
  mobMenuRay.style.height = mobMenuULHeight + 'px';
}

/* === // position and height of MOBILE RAY === */




/* === calculating MOBILE RAY PROGRESSING HEIGHT === */

let interval_MobMenuRay;

function mobRayHeightEval(){
  
  const mobMenuLinkList = mobHeadMenu.querySelector('ul');
  const mobMenuHeight = mobMenuLinkList.offsetHeight;

  let mobMenuLinkListTop = mobMenuLinkList.getBoundingClientRect().top;

  let mobMenuLinkListHeight = mobMenuLinkList.getBoundingClientRect().height;

  let pseudoOfList = getComputedStyle(mobMenuLinkList, "::after");

  let pseudoOfList__height = parseInt(pseudoOfList.height);

  for( let i in mobNavLIsTops_Array ){
    if( ( pseudoOfList__height + mobMenuLinkListTop ) >= mobNavLIsTops_Array[i] ){
      mobNavLIs[i].classList.add('opaque');
    }
  }

  if( (pseudoOfList__height) >= mobMenuHeight ) {
      clearInterval( interval_MobMenuRay );
  }
}

/* === // calculating MOBILE RAY PROGRESSING HEIGHT === */




/* === call of MOBILE MENU === */

openMobBtn.addEventListener("click", function(){

  if( mobHeadMenu.getAttribute("data-init") == "opened" ){

    if ( mobHeadMenu.classList.contains('menu--open') ){
      mobHeadMenu.classList.remove('menu--open');
      mobMenuCalc();
      mobHeader.classList.remove('shade');
    } else {
      mobHeadMenu.classList.add('menu--open');
      mobMenuCalc();
      mobHeader.classList.add('shade');
    }

  } else {
    mobHeadMenu.setAttribute("data-init", "opened");
    mobHeadMenu.classList.add('menu--open');
    mobHeader.classList.add('shade');
    mobMenuCalc();

    setTimeout( function(){
      fillMobMenuLIsTop();
      mobMenuUl.classList.add('rayIn');
      interval_MobMenuRay = setInterval( mobRayHeightEval, 20 );
    }, 400 );
  }
});

/* === // call of MOBILE MENU === */




/* === align DESK HEADER LOGO and TEASER DESK TEXT === */

function teaserLogoAlign () {
  let deskLogoHeight = deskLogo.offsetHeight;
  document.querySelector("#pageContent .teaser-print-wrap").style.height = deskLogoHeight + 'px';
}

/* === // align DESK HEADER LOGO and TEASER DESK TEXT === */




/* === calculate position of DESK RAY === */

function deskRayPosition(){
  const headerNavOffsetTop = headerNav.getBoundingClientRect().top;
  const headerNavOffsetRight = headerNav.getBoundingClientRect().right;
  menuRay.style.top = headerNavOffsetTop - 20 + 'px';
  menuRay.style.left = headerNavOffsetRight + 30 + 'px';
}

/* === // calculate position of DESK RAY === */




/* === calculate HEIGHT of DESK MENU === */

function headerMenuHeightCalc() {
  let winHeight = window.innerHeight;
  let headerMenuTop = headerNav.getBoundingClientRect().top;
  headerNav.style.height = (winHeight - ( headerMenuTop*2 ))+'px';
}

/* === // calculate HEIGHT of DESK MENU === */




/* === fill in DESK MENU LIs === */

function fillDeskNavLIs(){
  for( let i=0; i < desktopNavLIs.length; i++ ){
    const liTop = desktopNavLIs[i].getBoundingClientRect().top;
    desktopNavLIsTops_Array[i] = liTop;
  }
}

/* === // fill in DESK MENU LIs === */




/* === calculate HEIGHT of DESK RAY === */

function deskRayHeight(){
  menuRay.style.height = headerNav.offsetHeight + 15 + 'px';
}

/* === // calculate HEIGHT of DESK RAY === */




/* === calculate increasing height and position of RAY in DESK MENU === */

function deskRayHeightEval() {
  let intervalId;
  
  const headerNavHeight = headerNav.offsetHeight;
  const rayTop = menuRay.getBoundingClientRect().top;

  const rayHeight = menuRay.offsetHeight;

  for( let i in desktopNavLIsTops_Array ){
    if( (rayHeight + rayTop) >= desktopNavLIsTops_Array[i] ){
      desktopNavLIs[i].classList.add('opaque');
    }
  }

  if( rayHeight >= headerNavHeight ) {
      clearInterval( intervalId );
  }
}

/* === // calculate increasing height and position of RAY in DESK MENU === */




/* === PARALLAX for PICTOGRAMMS === */

const imgContentList = document.querySelectorAll('.img__content');

window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    const middleY = window.innerHeight / 2;
    let multFactor = (20/middleY);

    imgContentList.forEach(( imgContent ) => {
        const transparent = imgContent.querySelector('.img__transparent');
        let contentTop = imgContent.getBoundingClientRect().top;
        transparent.style.transform = 'translateY('+(-(contentTop-middleY)*multFactor)+'px';
    });
});

/* === // PARALLAX for PICTOGRAMMS === */




/* === recalculate and reassign new HEIGHT to PICTOGRAMMS === */

function pictogrammsRecalculation() {
  imgTiles.forEach( (tile) => {
    const tileWidth = tile.offsetWidth;
    if( tile.closest('.subsection') ){
      tile.style.height = (tileWidth * 1) + 'px';
    } else {
      tile.style.height = (tileWidth * 1.17) + 'px';
    }
  });
}

/* === // recalculate and reassign new HEIGHT to PICTOGRAMMS === */




/* === APPEARANCE OF SECTIONS WHILE SCROLLING === */

function sectionAppearanceSet(){
  const winScrollY = window.scrollY;
  const winFoldLine = window.innerHeight*0.5;

  for ( let i in appearsSections__Array ){
    if( (winScrollY+winFoldLine) >= appearsSections__Array[i] ){
      appearSections[i].classList.add('appears--true');

      if( appearSections[i].classList.contains('appears--true') ){
        
        if( appearSections[i].querySelector('.slogan hr') ){
          appearSections[i].querySelector('.slogan hr').classList.add('show');
        }

        if( appearSections[i].querySelector('.section-trail hr') ){
          appearSections[i].querySelector('.section-trail hr').classList.add('show');
        }

        setTimeout(function(){
          if( appearSections[i].querySelector('.section-title') ){
            appearSections[i].querySelector('.section-title').classList.add('show');
          }

          if( appearSections[i].querySelector('h2') ){
            appearSections[i].querySelector('h2').classList.add('show');
          }

          if( appearSections[i].querySelector('.img__content') ){
            appearSections[i].querySelector('.img__content').classList.add('show');
          }
          
          if( appearSections[i].querySelector('.slogan__text') ){
            appearSections[i].querySelector('.slogan__text').classList.add('show');
          }
          
          if( appearSections[i].querySelector('.text-content') ){
            appearSections[i].querySelector('.text-content').classList.add('show');
          }

          if( appearSections[i].querySelector('.text') ){
            appearSections[i].querySelector('.text').classList.add('show');
          }

          if( appearSections[i].querySelector('.sect-btns') ){
            appearSections[i].querySelector('.sect-btns').classList.add('show');
          }

          if( appearSections[i].querySelector('#partner-shortcuts') ){
            appearSections[i].querySelector('#partner-shortcuts').classList.add('show');
          }

          if( appearSections[i].querySelector('.mate') ){
            const mates = appearSections[i].querySelectorAll('.mate');
            mates.forEach( (mate) => {
              mate.classList.add('show');
            } );
          }

          if( appearSections[i].querySelector('.lead-text') ){
            appearSections[i].querySelector('.lead-text').classList.add('show');
          }

          if( appearSections[i].querySelector('.contact-form') ){
            appearSections[i].querySelector('.contact-form').classList.add('show');
          }
        }, 300)
      }
    }
  }

}

/* === // APPEARANCE OF SECTIONS WHILE SCROLLING === */



/* === Smooth jump to anchors === */

const anchorLinks = document.querySelectorAll('a[href^="#"]');

anchorLinks.forEach(anchorLink => {
  anchorLink.addEventListener('click', (e) => {
    e.preventDefault(); 
    const targetId = anchorLink.getAttribute('href').slice(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  });
});

/* === // Smooth jump to anchors === */




/* === externOutputWindow Stuff === */

function externOutputWindowsHeights(){
  externOutputWindows.forEach( (outputWindow) => {
    const outputWindowComputedStyle = window.getComputedStyle( outputWindow );

    const paddingTop = outputWindowComputedStyle.getPropertyValue('padding-top');
    const paddingBottom = outputWindowComputedStyle.getPropertyValue('padding-bottom');
    const innerHeaderHeight = outputWindow.querySelector('.externOutputWindow__inner-header').offsetHeight;
  
    let totalHeight = parseInt(paddingTop) + parseInt(paddingBottom) + innerHeaderHeight;
    let winHeight = window.innerHeight;
  
    outputWindow.querySelector('.externOutputWindow__inner-content').style.height = (winHeight - totalHeight) + 'px';
  });
}



/* === SCROLLING FX on DESK === */

externOutputWindows.forEach( (outputWindow) => {

  const container = outputWindow;
  const viewWindow = outputWindow.querySelector('.externOutputWindow__inner-content');
  const textContainer = outputWindow.querySelector('.inner-content__text');

  let isHovering = false;

  container.addEventListener('mouseenter', () => {
    isHovering = true;
  });

  container.addEventListener('mouseleave', () => {
    isHovering = false;
  });

  container.addEventListener('wheel', (e) => {

    const viewWindowHeight = viewWindow.offsetHeight;
    const textContainerHeight = textContainer.offsetHeight;

    if ( isHovering ) {
      const offsetTop = textContainer.offsetTop;
      const newOffsetTop = offsetTop - e.deltaY;

      if ( newOffsetTop <= ( viewWindowHeight - textContainerHeight ) ){
        textContainer.style.top = (viewWindowHeight - textContainerHeight) + 'px';
      } else if ( newOffsetTop >= 0 ){
        textContainer.style.top = 0 + 'px';
      } else {
        textContainer.style.top = newOffsetTop + 'px';
      }
      
      e.preventDefault();
    }
  });
});

/* === // SCROLLING FX on DESK === */



/* === SCROLLING FX on MOB === */

externOutputWindows.forEach( (outputWindow) => {

  let startY;
  let scrolling = false;
  const element = outputWindow.querySelector('.externOutputWindow__inner-content');

  element.addEventListener('touchstart', (e) => {
    startY = e.touches[0].clientY;
    scrolling = true;
  });

  element.addEventListener('touchmove', (e) => {
    if (!scrolling) return;

    const currentY = e.touches[0].clientY;
    const deltaY = startY - currentY;
    
    element.scrollTop += deltaY;
    
    e.preventDefault();

    startY = currentY;
  });

  element.addEventListener('touchend', () => {
    scrolling = false;
  });

});

/* === // SCROLLING FX on MOB === */

/* === // externOutputWindow Stuff === */




/* === set PLACEHOLDER for SUBJECT FIELD === */

const formSelectOptions = document.querySelectorAll('form select option');
formSelectOptions[0].innerText = "Ihr Anliegen";
formSelectOptions[0].style.display = "none";

/* === // set PLACEHOLDER for SUBJECT FIELD === */




/* === calculate HEIGHT of MESSAGE FIELD in CONTACT FORM === */

function setTextareaHeight(){
  const firm = contactForm.querySelector('[name="firm"]');
  const tel = contactForm.querySelector('[name="tel"]');
  const email = contactForm.querySelector('[name="email"]');
  const message = contactForm.querySelector('[name="message"]');

  let firmHeight = firm.offsetHeight + parseInt( (getComputedStyle(firm)).marginBottom );
  let telHeight = tel.offsetHeight + parseInt( (getComputedStyle(tel)).marginBottom );
  let emailHeight = email.offsetHeight;

  message.style.height = (firmHeight+telHeight+emailHeight)+'px';
}

/* === // calculate HEIGHT of MESSAGE FIELD in CONTACT FORM === */


const formAcceptanceField = contactForm.querySelector('input[name="acceptance"]');

if (formAcceptanceField) {
  formAcceptanceField.addEventListener("change", function () {
    if (formAcceptanceField.checked) {
      formAcceptanceField.classList.add("accept--checked");
    } else {
      formAcceptanceField.classList.remove("accept--checked");
    }
  });
}


const footer = document.querySelector("#footer");

function footerAppearance(){
  const winScrollY = window.scrollY;
  const winFoldLine = window.innerHeight*0.85;
  const footerOffset = getDistanceToDocumentTop(footer);

  if( (winScrollY + winFoldLine) >= footerOffset ){
    footer.classList.add('show');
  }
}





window.addEventListener("DOMContentLoaded", function(){
    mobMenuCalc();  
    headerMenuHeightCalc();
    fillDeskNavLIs();
    teaserLogoAlign();
    deskRayPosition();
    pictogrammsRecalculation();
    appearsDistanceToTop();
    setTextareaHeight();
    externOutputWindowsHeights();
    footerAppearance();
    //const sectionTrails = document.querySelectorAll('.section-trail');

    setTimeout( function(){
      deskLogo.classList.add('show');
      mobLogo.classList.add('show');

      teaserPrints.forEach( function( teaserPrint ){
          setTimeout( function(){
            teaserPrint.querySelector('.trail').classList.add('show');

            setTimeout( function(){
              teaserPrint.querySelector('p').classList.add('show');
              openMobBtn.classList.add('show');
              deskRayHeight();

              setTimeout( function(){
                sectionAppearanceSet();
              }, 600);
            }, 200);
          }, 200);
      });

      /* === increase DESKTOP RAY === */

      setTimeout( function(){
        intervalId = setInterval( deskRayHeightEval, 20 );
      }, 1000);

      /* === // increase DESKTOP RAY === */

    }, 1000 );    
});

window.addEventListener("resize", function(){
  mobMenuCalc();
  teaserLogoAlign();
  headerMenuHeightCalc();
  fillDeskNavLIs();
  deskRayPosition();
  deskRayHeight();
  pictogrammsRecalculation();
  appearsDistanceToTop();
  setTextareaHeight();
  sectionAppearanceSet();
  externOutputWindowsHeights();
  footerAppearance();
});

window.addEventListener("orientationchange", function(){
  mobMenuCalc();
  teaserLogoAlign();
  headerMenuHeightCalc();
  fillDeskNavLIs();
  deskRayPosition();
  deskRayHeight();
  pictogrammsRecalculation();
  appearsDistanceToTop();
  setTextareaHeight();
  sectionAppearanceSet();
  externOutputWindowsHeights();
  footerAppearance();
});


window.addEventListener( "scroll", function(){
  sectionAppearanceSet();
  footerAppearance();
});